<template>
  <div class="subscribe flex">
    <div class="form-field">
      <label for="subscribe">Exclusive offers and weekly specials</label>
      <input type="email" v-model="email" placeholder="Email address">
    </div>
    <button :disabled="isDisabled" @click="subscribe" class="button black">Submit</button>
  </div>
</template>

<script>
export default {
  props: {},
  
  data() {
    return {
      isDisabled: false,
      email: null
    }
  },
  
  mounted() {

  },
  
  methods: {
    
    subscribe() {
      if (this.email) {
        if (this.modValidateEmail(this.email)) {
          
          this.isDisabled = true
          
          window.axios.post('/api/subscribers', { email: this.email })
            .then(response => {
              
              this.$store.commit('setPopup', {
                open: true,
                content: '<p>The email ' + this.email + ' has been added to the subscriber list</p>'
              })
              
              this.isDisabled = false
              this.email = null
              
            })
            .catch(error => {
              this.$store.commit('setPopup', {
                open: true,
                content: '<p>' + error.response.data.message +'</p>'
              })
              
              this.isDisabled = false
            })
          
        } else {
          this.$store.commit('setPopup', {
            open: true,
            content: '<p>Invalid email address</p>'
          })
        }
      } else {
        this.$store.commit('setPopup', {
          open: true,
          content: '<p>Please enter email address</p>'
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-core/subscribers/Form.vue